import React from 'react';
import ChannelCard from './ChannelCard';

const Channels: React.FC = () => {
  return <ChannelCard />;
};

export default Channels;
